var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMarkGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 335.2 353.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #13c300;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.1,347c-89.6,0-163-73.3-163-163S77.5,21,167.1,21s163,73.3,163,163-73.3,163-163,163Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.4,272.3c-2.4,0-4.7-1-6.5-2.8l-58.9-61.9c-3.4-3.5-3.2-9.2.3-12.6,3.5-3.4,9.2-3.3,12.6.3l52,54.6,123.8-150.9c3.1-3.8,8.7-4.4,12.5-1.3,3.8,3.1,4.4,8.7,1.3,12.5l-130.2,158.7c-1.6,2-4,3.2-6.6,3.2h-.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkGreen);
export default __webpack_public_path__ + "static/media/CheckMark_Green.92c549ddc964098acdc1591aa1e1cf72.svg";
export { ForwardRef as ReactComponent };